import { FormEvent, useState } from "react";
import { Link, useSearchParams, useParams } from "react-router-dom";
import ApiService from "@/services/ApiService";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Panel,
  Feedback,
  useMutation,
  useData,
  LoadState,
  roles,
} from "@/pages/management/ui";
export function PasswordRecovery() {
  const [query] = useSearchParams();
  const token = query.get("token");
  const [email, setEmail] = useState(query.get("email") ?? "");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const op = useMutation();
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    await op.run(
      () =>
        token
          ? ApiService.post("auth/reset-password", {
              email,
              token,
              password,
              password_confirmation: confirmation,
            })
          : ApiService.post("auth/forgot-password", { email }),
      token
        ? "パスワードを更新しました。ログインしてください。"
        : "利用可能なアカウントがある場合、再設定メールを送信します。",
    );
    setPassword("");
    setConfirmation("");
  };
  return (
    <div className="max-w-lg p-6 mx-auto mt-12">
      <Panel title={token ? "パスワード再設定" : "パスワードを忘れた場合"}>
        <Feedback {...op} />
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            メールアドレス
            <Input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          {token && (
            <>
              <label className="block">
                新しいパスワード（12文字以上）
                <Input
                  required
                  minLength={12}
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
              <label className="block">
                パスワード確認
                <Input
                  required
                  minLength={12}
                  type="password"
                  value={confirmation}
                  onChange={(e) => setConfirmation(e.target.value)}
                />
              </label>
            </>
          )}
          <Button disabled={op.busy}>
            {token ? "更新" : "再設定メールを送信"}
          </Button>
        </form>
        <Link className="underline" to="/login">
          ログイン画面へ
        </Link>
      </Panel>
    </div>
  );
}
export function AcceptInvitation() {
  const { token } = useParams();
  const invitation = useData<{
    email: string;
    organization: string;
    account_exists: boolean;
    role_key: string;
  }>("invitations/" + token);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [otp,setOtp]=useState("");
  const op = useMutation();
  return (
    <div className="max-w-lg p-6 mx-auto mt-12">
      <Panel title="OOAK JOBへの招待">
        <LoadState {...invitation} />
        <Feedback {...op} />
        {invitation.data && (
          <form
            className="space-y-4"
            onSubmit={async (e) => {
              e.preventDefault();
              await op.run(
                () =>
                  ApiService.post("invitations/" + token + "/accept", {
                    password,
                    name,
                    otp: otp || null,
                  }),
                "参加しました。ログインしてご利用ください。",
              );
              setPassword("");
              setOtp("");
            }}
          >
            <p>
              {invitation.data.organization} · {roles[invitation.data.role_key]}
            </p>
            <p>{invitation.data.email}</p>
            {!invitation.data.account_exists && (
              <label className="block">
                お名前
                <Input
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </label>
            )}
            <label className="block">
              {invitation.data.account_exists
                ? "既存OOAKアカウントのパスワード"
                : "パスワード（12文字以上）"}
              <Input
                required
                minLength={invitation.data.account_exists ? 1 : 12}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            {invitation.data.account_exists && <label className="block">認証コード / リカバリーコード（MFA有効時）<Input autoComplete="one-time-code" value={otp} onChange={e=>setOtp(e.target.value)}/></label>}
            <Button disabled={op.busy || !!op.notice}>
              招待を承認して参加
            </Button>
          </form>
        )}
        <Link className="underline" to="/login">
          ログイン画面へ
        </Link>
      </Panel>
    </div>
  );
}
